export const LLMFeatureEnum = {
    CATEGORISE_DIALOG_INTERACTIONS: 'CATEGORISE_DIALOG_INTERACTIONS',
    CHOOSE_KNOWLEDGE_BY_BUSINESS_DESCRIPTION: 'CHOOSE_KNOWLEDGE_BY_BUSINESS_DESCRIPTION',
    DIRECT_LLM_CUSTOM_REQUEST: 'DIRECT_LLM_CUSTOM_REQUEST',
    KNOWLEDGE_BASE_MAKER: 'KNOWLEDGE_BASE_MAKER',
    PARALLEL_NLU: 'PARALLEL_NLU',
    RAG: 'RAG',
    SUGGEST_FORMULATIONS: 'SUGGEST_FORMULATIONS',
    SUMMARISE_CONVERSATIONS: 'SUMMARISE_CONVERSATIONS',
} as const;
export type LLMFeature = typeof LLMFeatureEnum[keyof typeof LLMFeatureEnum];